export const validationRules = {
  required: (value) => requiredValidation(value),
  dateIso: (value) => dateIsoValidation(value),
  dateAfter: (value, referenceValue) =>
    dateAfterValidation(value, referenceValue),
  onlyAlphabetic: (value) => onlyAlphabeticValidation(value),
  integerNumber: (value) => integerNumberValidation(value),
  decimalNumber: (value) => decimalNumberValidation(value),
  minNumber: (value, minNumber, isIncluded) =>
    minNumberValidation(value, minNumber, isIncluded),
  maxNumber: (value, maxNumber, isIncluded) =>
    maxNumberValidation(value, maxNumber, isIncluded),
  email: (value) => emailValidation(value),
  confirmEmail: (value, referenceValue) =>
    confirmEmailValidation(value, referenceValue),
  emailIason: (value) => emailIasonValidation(value),
  fileSize: (value) => fileSizeValidation(value),
  phoneLength: (value) => phoneLengthValidation(value),
  phone: (value) => phoneValidation(value),
  textLength: (value, maxLength) => textLengthValidation(value, maxLength),
  address: (value) => addressValidation(value),
};

function requiredValidation(inputToValidate) {
  const requiredCheck =
    inputToValidate != null &&
    inputToValidate.length !== 0 &&
    inputToValidate !== undefined;
  return requiredCheck || "This field is required.";
}

function dateIsoValidation(inputToValidate) {
  return (
    inputToValidate.length == 8 || "Date must be 8 chars with format yyyyMMdd."
  );
}

function dateAfterValidation(inputToValidate, referenceValue) {
  if (!inputToValidate) return true;
  let inputDate = new Date(inputToValidate);
  let referenceDate = new Date(referenceValue);
  return (
    inputDate.getTime() > referenceDate.getTime() ||
    `Date must be after ${referenceValue}`
  );
}

function onlyAlphabeticValidation(inputToValidate) {
  let regex = /^[a-zA-Z]+$/;
  return regex.test(inputToValidate) || "Only alphabetical characters allowed";
}

function integerNumberValidation(inputToValidate) {
  if (
    inputToValidate === null ||
    inputToValidate === undefined ||
    inputToValidate === ""
  )
    return true;
  const regex = /^[0-9]+$/;
  return regex.test(inputToValidate) || "Invalid integer number";
}

function decimalNumberValidation(inputToValidate) {
  let initialString = inputToValidate.toString();
  let arrayString = initialString.split(",");

  let finalString = "";
  let finalNumber;
  if (arrayString.length == 2) {
    finalString = arrayString[0] + "." + arrayString[1];
    finalNumber = parseFloat(finalString);
  } else if (arrayString.length == 1) {
    finalString = arrayString[0];
    finalNumber = finalString;
  }
  let regex = /^\d+(\.\d{1,2})?$/;
  return regex.test(finalNumber) || "Invalid decimal number";
}

function minNumberValidation(inputToValidate, minNumber, isIncluded) {
  if (inputToValidate) {
    if (isIncluded) {
      return (
        inputToValidate >= minNumber ||
        `Number must be greater or, at least, ${minNumber}`
      );
    } else {
      return (
        inputToValidate > minNumber || `Number must be greater of ${minNumber}`
      );
    }
  } else {
    return true;
  }
}

function maxNumberValidation(inputToValidate, maxNumber, isIncluded) {
  if (inputToValidate) {
    if (isIncluded) {
      return (
        inputToValidate <= maxNumber ||
        `Number must be smaller or, at most, ${maxNumber}`
      );
    } else {
      return (
        inputToValidate < maxNumber || `Number must be smaller of ${maxNumber}`
      );
    }
  } else {
    return true;
  }
}

function emailValidation(inputToValidate) {
  const pattern =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return pattern.test(inputToValidate) || "Invalid e-mail.";
}

function confirmEmailValidation(inputToValidate, referenceValue) {
  return inputToValidate == referenceValue || "E-mail does not match.";
}

function emailIasonValidation(inputToValidate) {
  const pattern =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@iasonltd\.com$/;
  return pattern.test(inputToValidate) || "E-mail must be iasonltd.com domain";
}

function fileSizeValidation(inputToValidate) {
  return (
    !inputToValidate ||
    inputToValidate.size < 2000000 ||
    "File size should be less than 2 MB!"
  );
}

function phoneLengthValidation(inputToValidate) {
  return (
    inputToValidate.length <= 14 || "Phone number can't be longer than 14 char"
  );
}
function phoneValidation(inputToValidate) {
  const pattern = /^(\+|00)[1-9][0-9 \-().]{7,32}$/;
  return (
    !inputToValidate ||
    pattern.test(inputToValidate) ||
    "Invalid phone format. Must be +XX-123456789"
  );
}

function addressValidation(inputToValidate) {
  const pattern = /^[A-Za-z\s']+, \d+$/;
  return (
    !inputToValidate ||
    pattern.test(inputToValidate) ||
    'Invalid address. Must be "Street, Number"'
  );
}

function textLengthValidation(value, maxLength) {
  return (
    (value && value.length <= maxLength) ||
    `The field must be less than ${maxLength} characters`
  );
}

/*
ISTRUZIONI PER L'UTILIZZO DELLE RULES IN OGNI VISTA

1) Importare i validators
import { Validators } from "../../utility/validators.js";

2) Inserire le rules nei data del componente
rules: { ...Validators.rules },

3) Inserire nell'html un v-form che racchiuda tutti i campi con delle rules ed assegnargli un ref (in questo caso form)
<v-form ref="form">
.....
</v-form>

4) Assegnare le specifiche rules come attributes di un determinato campo di input all'interno di un array
<v-text-field :rules="[ rules.required, rules.integerNumber ]"

5) Creare un metodo che validi il form
validateFields: function() {
    return this.$refs.form.validate();
},

6) Porre il metodo di validazione precedentemente creato come condizione per il salvataggio dei dati
saveData: async function() {
    if(this.validateFields) {
        do something ...
    }
}

7) Eventualmente creare una computed ed un watcher per cambiare la virgola dei numeri decimali con un punto
computed: {
    inputDecimalList: function() {
        let dataModelsList = [
            "objectModel1.key1",
            "objectModel1.key2",
            "model2"
        ]
        let object = {
            values: `${this.objectModel1.key1}|${this.objectModel1.key2}|${this.model2}`,
            models: [...dataModelsList]
        }
        return object
    },
},
watch: {
    inputDecimalList: function(value) {
        const vm = this;
        Formatters.formatAllDecimalNumberWithDot(value, vm)
    }
},
*/

/*
ISTRUZIONI PER L'AGGIUNTA DI UNA RULE ALL'INTERNO DELL'OGGETTO RULES

1) Creare una funzione che esegue la validazione
static requiredValidation(inputToValidate) {
    return (inputToValidate !== null && inputToValidate !== undefined && inputToValidate !== "") || "Required";
}

2) Assegnarla come ad una chiave dell'oggetto rules tramite arrow function
static rules = {
    required: (value) => this.requiredValidation(value),
    ...
}
*/
